import React, { useRef } from 'react';
var VeltTextComment = function (props) {
    var defaultCondition = props.defaultCondition, variant = props.variant, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-text-comment", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, variant: variant }, children));
};
export default VeltTextComment;
